class FullImageMarquee extends HTMLElement {
    constructor() {
        super();
        this.marqueeTrack = this.querySelector('.marquee-track');
        this.scrollDirection = this.dataset.direction || 'left';
        this.scrollSpeed = this.dataset.speed || 3;
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        
        this.init();
    }
    
    init() {
        this.setupDirection();
        this.setupPauseOnHover();
        this.setupResponsiveBehavior();
    }
    
    setupDirection() {
        if (this.scrollDirection === 'right') {
            this.marqueeTrack.setAttribute('data-direction', 'right');
        }
    }
    
    setupPauseOnHover() {
        if (this.pauseOnHover) {
            this.setAttribute('data-pause-hover', 'true');
        }
    }
    
    setupResponsiveBehavior() {
        // Adjust speed on mobile for better performance
        if (window.innerWidth <= 768) {
            const mobileSpeed = Math.max(1, this.scrollSpeed - 1);
            this.marqueeTrack.setAttribute('data-speed', mobileSpeed);
        }
        
        // Listen for resize events
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.setupResponsiveBehavior();
            }, 250);
        });
    }
    
    // Method to update speed dynamically
    updateSpeed(newSpeed) {
        this.scrollSpeed = newSpeed;
        this.marqueeTrack.setAttribute('data-speed', newSpeed);
    }
    
    // Method to update direction dynamically
    updateDirection(newDirection) {
        this.scrollDirection = newDirection;
        this.marqueeTrack.setAttribute('data-direction', newDirection);
    }
    
    // Method to pause/resume animation
    pause() {
        this.marqueeTrack.style.animationPlayState = 'paused';
    }
    
    resume() {
        this.marqueeTrack.style.animationPlayState = 'running';
    }
}

// Register the custom element
customElements.define('full-image-marquee', FullImageMarquee);

// Initialize all marquees on the page
document.addEventListener('DOMContentLoaded', () => {
    const marquees = document.querySelectorAll('full-image-marquee');
    marquees.forEach(marquee => {
        if (!marquee.initialized) {
            marquee.initialized = true;
        }
    });
});
